export { default as CreateEditBienvenida } from './CreateEditBienvenidaContainer';
